import { render, staticRenderFns } from "./YcDatePicker.vue?vue&type=template&id=2649ed4a&scoped=true&lang=pug&"
import script from "./YcDatePicker.vue?vue&type=script&lang=js&"
export * from "./YcDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./YcDatePicker.vue?vue&type=style&index=0&id=2649ed4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2649ed4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
